import { render, staticRenderFns } from "./LiveStart.vue?vue&type=template&id=206ffc5e&scoped=true&"
import script from "./LiveStart.vue?vue&type=script&lang=js&"
export * from "./LiveStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206ffc5e",
  null
  
)

export default component.exports